import { useStatsigClient } from '@statsig/react-bindings';
import { Card } from '@components/sds/card/card';
import DownloadToIcon from '@components/sds/icons/download-to';
import styles from './download-card.module.scss';

export interface DownloadCardProps {
  title: string;
  url: string;
}

export const DownloadCard = ({ title, url }: DownloadCardProps) => {
  const { logEvent } = useStatsigClient();

  const onClick = () => {
    window.URL = window.URL || window.webkitURL;

    //Use xhr hack to force a human-readable filename
    const xhr = new XMLHttpRequest();
    const a = document.createElement('a');
    let file;

    xhr.open('GET', url, true);
    xhr.responseType = 'blob';

    xhr.onload = function () {
      file = new Blob([xhr.response], { type: 'application/octet-stream' });
      a.href = window.URL.createObjectURL(file);
      a.download = `${title.replace(/ /g, '_')}.${url.split('.').pop()}`;
      a.click();
    };

    xhr.send();

    logEvent('download_card_click', title, { title, url });
  };

  return (
    <Card onClick={onClick}>
      <div className={styles.content}>
        <span>{title}</span>

        <DownloadToIcon className={styles.icon} />
      </div>
    </Card>
  );
};
